import { createApp } from 'vue';
import App from './App.vue';
import CollegeTable from './components/CollegeTable.vue';
import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dropdown from 'primevue/dropdown';

import 'primeicons/primeicons.css'
import './index.css'
import presetTheme from './tailwind-presets/college-search';

const app = createApp(App);

// Only the three components the results table resolves from templates are
// registered globally. DataTable pulls in its own paginator internals, so they
// don't need registering here.
app
  .use(PrimeVue, {
    unstyled: true,
    pt: presetTheme,
  })
  .component(CollegeTable.name, CollegeTable)
  .component(DataTable.name, DataTable)
  .component(Column.name, Column)
  .component(Dropdown.name, Dropdown)
  .mount('#app');
